import { render } from "./PostCustumers.vue?vue&type=template&id=1ad140d2&scoped=true"
import script from "./PostCustumers.vue?vue&type=script&lang=js"
export * from "./PostCustumers.vue?vue&type=script&lang=js"

import "./PostCustumers.vue?vue&type=style&index=0&id=1ad140d2&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad140d2"]])

export default __exports__